import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 's18-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit {
  @ViewChild('file') fileInput;

  @Output() addComplete = new EventEmitter<string>();

  allHoles:
    {
      desc: string;
      value: number;
    }[];

  imgCheck = new Image();

  assigned_to_hole = 0;
  uploading: boolean = false;
  fileToUpload: File;

  width: number;
  height: number;
  showHole: boolean = true;

  constructor(
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.allHoles = [
      { desc: 'Random Hole', value: 0 },
      { desc: 'Leaderboard', value: 19 },
      { desc: 'Hole 1', value: 1 },
      { desc: 'Hole 2', value: 2 },
      { desc: 'Hole 3', value: 3 },
      { desc: 'Hole 4', value: 4 },
      { desc: 'Hole 5', value: 5 },
      { desc: 'Hole 6', value: 6 },
      { desc: 'Hole 7', value: 7 },
      { desc: 'Hole 8', value: 8 },
      { desc: 'Hole 9', value: 9 },
      { desc: 'Hole 10', value: 10 },
      { desc: 'Hole 11', value: 11 },
      { desc: 'Hole 12', value: 12 },
      { desc: 'Hole 13', value: 13 },
      { desc: 'Hole 14', value: 14 },
      { desc: 'Hole 15', value: 15 },
      { desc: 'Hole 16', value: 16 },
      { desc: 'Hole 17', value: 17 },
      { desc: 'Hole 18', value: 18 },
    ]
  }

  getFileName() {
    if (this.fileToUpload) {
      return this.fileToUpload.name;
    }
    return "Select a File!"
  }

  showFilePicker() {
    this.fileInput.nativeElement.click();
  }

  setFile() {
    this.imgCheck = new Image();
    this.fileToUpload = this.fileInput.nativeElement.files[0];
    this.imgCheck.src = window.URL.createObjectURL(this.fileToUpload);
  }

  fileSelected() {
    return this.fileInput.nativeElement.files && this.fileInput.nativeElement.files.lenght > 0;
  }

  uploadFile() {
    if (!this.checkFileSize()) {
      this.fileToUpload = null;
      this.fileInput.nativeElement.value = '';
      return;
    }
    this.saveFile();
  }

  checkFileSize() {
    if (this.imgCheck.naturalHeight === this.height && this.imgCheck.naturalWidth === this.width) {
      return true;
    }
    this.snackBar.open("Images must be in PNG format and exactly " + this.width + "x" + this.height + "px", null, { panelClass: 'warning-toast', duration: 3000, verticalPosition: 'top', horizontalPosition: 'right' });
    return false;
  }


  saveFile() {
    //no-op;
  }
}
